import type { Nsid } from '@atcute/lexicons/syntax';

import { DEFAULT_TANGLED_APPVIEW_SERVICE } from '../settings';

export const PUBLIC_API_SERVICE = 'https://public.api.bsky.app';
export const CONSTELLATION_SERVICE = 'https://constellation.microcosm.blue';
export const SLINGSHOT_SERVICE = 'https://slingshot.microcosm.blue';
export const SPACEDUST_SERVICE = 'wss://spacedust.microcosm.blue/subscribe';
export const TANGLED_APPVIEW_SERVICE = DEFAULT_TANGLED_APPVIEW_SERVICE;

export const TANGLED_OAUTH_SCOPE = import.meta.env.VITE_OAUTH_SCOPE;

export const REPO_COLLECTION: Nsid = 'sh.tangled.repo';
export const STAR_COLLECTION: Nsid = 'sh.tangled.feed.star';
export const ACTOR_PROFILE_COLLECTION: Nsid = 'sh.tangled.actor.profile';
export const APP_BSKY_PROFILE_COLLECTION: Nsid = 'app.bsky.actor.profile';
export const ISSUE_COLLECTION: Nsid = 'sh.tangled.repo.issue';
export const ISSUE_COMMENT_COLLECTION: Nsid = 'sh.tangled.repo.issue.comment';
export const ISSUE_STATE_COLLECTION: Nsid = 'sh.tangled.repo.issue.state';
export const PULL_COLLECTION: Nsid = 'sh.tangled.repo.pull';
export const PULL_COMMENT_COLLECTION: Nsid = 'sh.tangled.repo.pull.comment';
export const PULL_STATUS_COLLECTION: Nsid = 'sh.tangled.repo.pull.status';
export const FEED_COMMENT_COLLECTION: Nsid = 'sh.tangled.feed.comment';
export const STRING_COLLECTION: Nsid = 'sh.tangled.string';
export const WATCH_COLLECTION: Nsid = 'place.wisp.untangled.v1.watch';
